import { render, staticRenderFns } from "./BgpSessions.vue?vue&type=template&id=123c19cd"
import script from "./BgpSessions.vue?vue&type=script&lang=js"
export * from "./BgpSessions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports